import { render, staticRenderFns } from "./DownloadPdfList.vue?vue&type=template&id=581464f3&scoped=true&"
import script from "./DownloadPdfList.vue?vue&type=script&lang=js&"
export * from "./DownloadPdfList.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPdfList.vue?vue&type=style&index=0&id=581464f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581464f3",
  null
  
)

export default component.exports